import CalendarPage from "@/pages/calendar"
import { Navigate, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "calendar",
  element: <CalendarPage />,
  children: [
    {
      path: "*",
      element: <Navigate to="calendar" replace />,
    },
  ],
}

export default routes
